@if (showCaption()) {
  <span
    class="content"
    [animate.enter]="withAnimation() ? 'caption-enter' : null"
    [animate.leave]="withAnimation() ? 'caption-leave' : null"
  >
    <ng-content />
  </span>
}

@if (icon(); as icon) {
  <span class="icon" [class]="icon"></span>
}
